var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowserCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 41,
    viewBox: "0 0 46 41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46 35.143C46 38.373 43.421 41 40.25 41H5.75C2.574 41 0 38.373 0 35.143V5.857C0 2.622 2.574 0 5.75 0h34.5C43.421 0 46 2.622 46 5.857v29.286zM8.625 11.714c1.59 0 2.875-1.308 2.875-2.928 0-1.62-1.285-2.929-2.875-2.929-1.588 0-2.875 1.309-2.875 2.929 0 1.62 1.287 2.928 2.875 2.928zm8.625-5.857c-1.59 0-2.875 1.309-2.875 2.929 0 1.62 1.285 2.928 2.875 2.928s2.875-1.308 2.875-2.928c0-1.62-1.285-2.929-2.875-2.929zm8.625 5.857c1.59 0 2.875-1.308 2.875-2.928 0-1.62-1.285-2.929-2.875-2.929S23 7.166 23 8.786c0 1.62 1.285 2.928 2.875 2.928z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.876 19.345-8.096-3.35a2.433 2.433 0 0 0-.777-.154c-.224 0-.572.07-.779.155l-8.095 3.349c-.756.309-1.249 1.042-1.249 1.816 0 10.804 7.978 16.112 10.116 16.112 2.159 0 10.124-5.367 10.124-16.112 0-.774-.493-1.507-1.244-1.816zm-4.763 4.863c0 .231-.08.463-.245.653L22.8 29.54c-.284.33-.661.313-.771.313-.27 0-.529-.106-.72-.294l-2.032-2.006c-.2-.157-.298-.417-.298-.71a1.01 1.01 0 0 1 1.016-1.002c.26 0 .52.098.72.294l1.257 1.24 3.352-3.859c.201-.23.486-.349.772-.349.778.037 1.016.73 1.016 1.04z",
    fill: "#1ED061"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowserCheck);
export default __webpack_public_path__ + "static/media/browser_check.6e6fe216e0c1c328e6bb5e3e65d89a57.svg";
export { ForwardRef as ReactComponent };